export const createInboxRefreshScheduler = (refresh: () => void, delay = 250) => {
  let timer: ReturnType<typeof setTimeout> | undefined;

  return {
    schedule: () => {
      if (timer) return;
      timer = setTimeout(() => {
        timer = undefined;
        refresh();
      }, delay);
    },
    cancel: () => {
      clearTimeout(timer);
      timer = undefined;
    },
  };
};
